// Product Collections State

export default {
  collectionList: [],
  collectionInfo: {}
}
